import { Box, Paper, TextField, IconButton, Button } from '@mui/material';
import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

const colors = [
    '#FF0000', '#0000FF', '#FFFF00', '#FFFFFF', '#000000',
    '#660099', '#b2d9f4', '#009933', '#FF9900', '#990000',
    '#000066', '#B3B3B3',
];

export const ColorPicker = ({ label, color, setColor }) => {
    const [open, setOpen] = useState(false);
    const [customColor, setCustomColor] = useState(color);

    // Fonction de validation d'un code hexadécimal
    const isValidHex = (color) => /^#([0-9A-F]{3}|[0-9A-F]{6})$/i.test(color);

    return (
        <Box style={{ position: 'relative' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <label style={{ padding: '5px'}}>{label}</label>
                <div style={{ margin: '5px'}}>
                    <div
                        onClick={() => setOpen(!open)}
                        style={{
                            width: '130px',
                            height: '20px',
                            backgroundColor: color,
                            border: '4px solid var(--color-light-grey)',
                            cursor: 'pointer',
                        }}
                    />
                    {open && (
                        <Paper
                            elevation={3}
                            style={{
                                position: 'absolute',
                                top: '40px',
                                right: 0,
                                display: 'grid',
                                gridTemplateColumns: 'repeat(4, 1fr)',
                                gap: '5px',
                                padding: '15px',
                                background: '#fff',
                                zIndex: 1000,
                                width: '150px',
                            }}
                        >
                            {/* Bouton de fermeture */}
                            <IconButton
                                size="small"
                                onClick={() => setOpen(false)}
                                style={{
                                    position: 'absolute',
                                    top: '5px',
                                    right: '5px',
                                    padding: '0',
                                }}
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>

                            {/* Palette de couleurs */}
                            {colors.map((c) => (
                                <div
                                    key={c}
                                    onClick={() => {
                                        setColor(c);
                                        setCustomColor(c);
                                    }}
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        backgroundColor: c,
                                        cursor: 'pointer',
                                        border: '1px solid #ccc',
                                    }}
                                />
                            ))}

                            {/* Input hexadécimal + bouton Valider */}
                            <Box sx={{ gridColumn: 'span 4', display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <TextField
                                value={customColor}
                                onChange={(e) => setCustomColor(e.target.value)}
                                size="small"
                                variant="outlined"
                                error={!isValidHex(customColor)}
                                helperText={!isValidHex(customColor) ? "Code hex invalide" : ""}
                                sx={{ flex: 1 }}
                                InputProps={{
                                    style: { fontSize: '12px' } // Réduit la taille du texte saisi
                                }}
                                InputLabelProps={{
                                    style: { fontSize: '12px' } // Réduit la taille du label (si utilisé)
                                }}
                            />
                                <Button
                                    onClick={() => {
                                        if (isValidHex(customColor)) {
                                            setColor(customColor);
                                            setOpen(false);
                                        }
                                    }}
                                    size="small"
                                    variant="contained"
                                >
                                    OK
                                </Button>
                            </Box>
                        </Paper>
                    )}
                </div>
            </Box>
        </Box>
    );
};